import LearningLabs from "../../../../src/components/Sessions/LearningLabs";
import * as React from 'react';
export default {
  LearningLabs,
  React
};